// @flow
import React, { type Node, type ComponentType } from 'react';
import styled from 'styled-components';
import { colors, fontWeight, withOpacity } from '../constants';

type ListItemProps = {
  active?: boolean,
  children?: Node,
  key?: string | number,
  url: string,
};

type ListProps = {
  children?: Node,
};

function List(props: ListProps) {
  return <StyledList>{props.children}</StyledList>;
}

function ListItem(props: ListItemProps) {
  const { active, children, key, url, ...rest } = props;
  return (
    <StyledListItem active={active} key={key}>
      <StyledItemLink href={url} bold={active} {...rest}>
        {children}
      </StyledItemLink>
    </StyledListItem>
  );
}

const SideNavigation: { [string]: ComponentType<any> } = {
  List,
  ListItem,
};

export default SideNavigation;

const StyledList = styled.ul`
  max-width: 198px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const StyledListItem = styled.li`
  width: 100%;
  border: 1px solid transparent;
  border-radius: 2px;
  background-color: ${(props) =>
    props.active ? withOpacity(colors.mediumGreenhouseGreen, 0.15) : 'initial'};

  :hover,
  :active {
    background-color: ${(props) => !props.active && colors.lightGrey};
    text-decoration: none;
  }
`;

const StyledItemLink = styled.a`
  display: block;
  text-decoration: none;
  color: ${colors.darkestGrey};
  padding: 6px 16px;

  :hover,
  :active {
    text-decoration: none;
  }

  ${(props) => (props.bold ? fontWeight('heavy') : fontWeight('normal'))}
`;
